import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.7 6.16-6-5.867a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37l5.3 5.18-5.3 5.181a.93.93 0 0 0 0 1.37c.2.194.5.292.7.292s.5-.098.7-.293l6-5.866a.93.93 0 0 0 0-1.368M7.7.292a.98.98 0 0 0-1.4 0L.3 6.16a.93.93 0 0 0 0 1.37l6 5.864c.2.195.4.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.369l-5.3-5.18 5.3-5.182a.93.93 0 0 0 0-1.369"
    }, null, -1)
  ]))]))
}
export default { render: render }